/*  
  Date: 25-09-2023 
  Author: Shubham Sonkar 
  Import the Axios library
*/
import axios from "axios";

/*  
  Date: 25-09-2023 
  Author: Shubham Sonkar
  Set a default configuration for Axios to include credentials with requests
*/
axios.defaults.withCredentials = true;

/*  
  Date: 25-09-2023 
  Author: Shubham Sonkar
  Create and export an instance of Axios with a specific baseURL
*/

export default axios.create({
  /*  
    Date: 25-09-2023 
    Author: Shubham Sonkar
    Set the base URL for the requests
  */
  // baseURL: window._env_.REACT_APP_BASE_URL, // Use this for local development
  // baseURL: "https://api.test.rabsconnect.in", // Use this for production
  // baseURL: "https://backend.crm.aarohanrealty.in", // Use this for production
  // baseURL: "https://backend.crm.saikrupapropertyconsultant.com", // Use this for production
  // baseURL: "https://backend.crm.kwick.co.in", // Use this for production
    // baseURL: "https://backend.newcrm.sippyhousing.in.net", // Use this for production
  baseURL: "https://backend.crm.fortunedxb.com", // Use this for production
  // baseURL: "https://demobackend.rabsconnect.in", // Use this for production
});
